import { createCrudSlice } from '../createCrudSlice';
import paymentsService from '@/services/payments.service';

// Payments are read-only data; create/update/delete thunks go unused (ops actions via service).
const { reducer, thunks } = createCrudSlice('payments', paymentsService);
export const { fetchList: fetchPayments } = thunks;
export default reducer;
